import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-avm-bg/90 backdrop-blur-md border-b border-avm-border py-4' : 'bg-transparent py-6'}`} data-id="element-115">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-116">
        <div className="flex items-center gap-3 cursor-pointer group" onClick={() => scrollTo('hero')} data-id="element-117">
          <img src="https://cdn.magicpatterns.com/uploads/1Wt6xZ2CEnACLmcpPMDgdq/pasted-image.jpg" alt="AVM Logo" className="h-8 md:h-10 object-contain logo-blend opacity-90 group-hover:opacity-100 transition-opacity" data-id="element-118" />
          <span className="font-sans font-medium text-sm tracking-wide hidden sm:block text-avm-text/90 group-hover:text-avm-text transition-colors" data-id="element-119">
            Atlas Ventures Management LLC
          </span>
        </div>

        <div className="flex items-center gap-6 md:gap-10 text-sm font-medium tracking-wide text-avm-text/70" data-id="element-120">
          {['About', 'Focus', 'Portfolio', 'Contact'].map(item => <button key={item} onClick={() => scrollTo(item.toLowerCase())} className="hover:text-avm-accent transition-colors duration-300" data-id="element-121">
              {item}
            </button>)}
        </div>
      </div>
    </motion.nav>;
}